// extracted by mini-css-extract-plugin
module.exports = {"avatar":"assistant-avatar_avatar__OXauU","portrait":"assistant-avatar_portrait__iK82L"};